import LegalPage, { P, UL, Strong } from "@/components/LegalPage";

const sections = [
  {
    id: "nature-of-business",
    heading: "Nature of the Business: Service Provider & Purchasing Agent",
    body: (
      <>
        <P>
          PS GLOBAL SERIES, LLC operates strictly as a{" "}
          <Strong>B2B Service Provider and Purchasing Agent</Strong> — a
          sourcing agency and trade liaison whose function is to facilitate
          commercial connections, negotiations, purchase management and
          logistics coordination between counterparties in the United States
          and the Dominican Republic across various industries.
        </P>
        <P>
          <Strong>Intermediation Statement:</Strong> The Company acts
          exclusively as a consultant, purchasing agent and intermediary. PS
          GLOBAL SERIES, LLC does NOT manufacture, take ownership of, store,
          transport, nor act as the final seller of the physical goods traded
          between the Client and the Supplier. All inventory purchase
          transactions are executed under agreements stipulated directly
          between the buyer and the final supplier; our company is paid for
          its service fees and never takes title to any merchandise.
        </P>
      </>
    ),
  },
  {
    id: "fees-and-payments",
    heading: "Fees and Payment Processing",
    body: (
      <UL
        items={[
          <>
            <Strong>Service Fees:</Strong> PS GLOBAL SERIES, LLC fees (which
            may include retainer fees, hourly consulting fees, or
            intermediation commissions) shall be clearly defined in an
            independent commercial agreement (Statement of Work) before any
            work begins.
          </>,
          <>
            <Strong>B2B Payments:</Strong> All fees for our intermediation
            services are settled via secure bank invoicing and wire
            transfer in US Dollars. Card payment through Stripe is
            available as a secondary option upon written request from the
            Client.
          </>,
        ]}
      />
    ),
  },
  {
    id: "absence-of-warranties",
    heading: "Absence of Warranties on Physical Products",
    body: (
      <P>
        Given that we are not the manufacturers, owners or sellers of the
        physical products, PS GLOBAL SERIES, LLC does not offer explicit or
        implicit warranties regarding the commercial quality, fitness for a
        particular purpose, or timeliness of delivery of any physical goods.
        We mitigate risks through audits and due diligence, but the Client
        assumes the final risk associated with international importation and
        manufacturing. Returns and replacements of physical goods are
        governed strictly by the policies of the original suppliers; PS
        GLOBAL SERIES, LLC assists only as an intermediary in the management
        of the claim.
      </P>
    ),
  },
  {
    id: "cancellation-and-refunds",
    heading: "Cancellation and Refund Policy",
    body: (
      <P>
        Due to the time- and effort-based nature of our consulting,
        negotiation, and supplier sourcing services, the fees and retainers
        paid to PS GLOBAL SERIES, LLC are{" "}
        <Strong>non-refundable</Strong> once the research or liaison work has
        commenced. In the event of project cancellation by the Client, only
        the intermediation services rendered up to the notification date
        will be billed.
      </P>
    ),
  },
  {
    id: "limitation-of-liability",
    heading: "Limitation of Liability",
    body: (
      <P>
        To the maximum extent permitted by applicable law, PS GLOBAL SERIES,
        LLC shall not be liable for indirect, incidental, or consequential
        damages arising from quality disputes, supply chain interruptions, or
        contract breaches by third-party suppliers or buyers in either the
        United States or the Dominican Republic.
      </P>
    ),
  },
  {
    id: "jurisdiction-and-applicable-law",
    heading: "Jurisdiction and Applicable Law",
    body: (
      <P>
        These Terms of Service shall be governed by and interpreted in
        accordance with the laws of the State of New Mexico, United States,
        without regard to its conflict-of-laws principles. Any legal disputes
        arising from these terms shall be resolved exclusively in the
        competent courts of the State of New Mexico.
      </P>
    ),
  },
  {
    id: "contact",
    heading: "Contact",
    body: (
      <P>
        For corporate inquiries:{" "}
        <a
          href="mailto:info@psglobalseries.com"
          className="text-slate-900 font-semibold hover:text-[#B45309]"
        >
          info@psglobalseries.com
        </a>
        .
      </P>
    ),
  },
];

export default function TermsOfService() {
  return (
    <LegalPage
      testId="page-terms-of-service"
      eyebrow="Legal"
      title="Terms of Service"
      lastUpdated="June 2026"
      intro={
        <>
          Welcome to psglobalseries.com (the “Website”), operated by PS
          GLOBAL SERIES, LLC (“the Company”, “we”, “us” or “our”). By
          accessing or using our commercial intermediation services,
          supplier sourcing, and international negotiation facilitation
          (the “Services”), you (the “Client” or “Buyer”) agree to be
          bound by the following Terms of Service.
        </>
      }
      sections={sections}
    />
  );
}
